module.exports = __webpack_public_path__ + "img/4U.30d0dea2.png";